import './style.css';

const ToggleButton = (props) => {

    return<div className="">
        <label className="switch">
            <input 
                type="checkbox" 
                name={props?.name}
                checked={props?.value}
                onChange={(e) => props?.handleChange(props?.name, e?.target?.checked)} 
            />
            <span className="slider round"></span>
        </label>
    </div>
}

export default ToggleButton;
